import CandidateFilterAutoComplete, {
  AutoCompleteProps,
} from './CandidateFilterAutocomplete.container';

export type AutoCompleteTypes = AutoCompleteProps;

export default CandidateFilterAutoComplete;
